export default [{
  name: 'woori-crowdfunding',
  path: '/woori-crowdfunding',
  meta: {
    layout: 'LegacyLayoutFluid'
  },
  component: require('@/pages/woori-crowdfunding/WooriCrowdfunding.vue').default
}]
